import cx from 'classnames';
import {
  ITableContainerFooterProps,
  ITableContainerHeaderProps,
  ITableContainerProps,
  TableContainer as UiTableContainer,
} from 'components/ui';
import css from './Table.module.scss';

const Header = ({
  children,
  className,
  ...rest
}: ITableContainerHeaderProps) => (
  <UiTableContainer.Header className={cx(css.header, className)} {...rest}>
    {children}
  </UiTableContainer.Header>
);

const Footer = ({
  children,
  className,
  ...rest
}: ITableContainerFooterProps) => (
  <UiTableContainer.Footer className={cx(css.footer, className)} {...rest}>
    {children}
  </UiTableContainer.Footer>
);

const TableContainer = ({ className, ...rest }: ITableContainerProps) => (
  <UiTableContainer className={cx(css.container, className)} {...rest} />
);

TableContainer.Header = Header;
TableContainer.Footer = Footer;
TableContainer.Title = UiTableContainer.Title;

export { Table } from 'components/ui';
export { TableContainer };
